import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LandingService } from '../../_services/landing.service';
import { ItemsPerPage } from 'src/app/_utlis/pagination-helper';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { LocalDateTimePipe } from 'src/app/Shared/_pipes/local-date-time';
import { SkeletonLoaderComponent } from 'src/app/Shared/components/skeleton-loader/skeleton-loader.component';
import { JqueryInitService } from 'src/app/Core/_services/jquery/jquery-init.service';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

export interface BlogItem {
  id: number;
  image: string;
  title: string;
  description: string;
  date: string;
  link: string;
}
@Component({
  selector: 'app-blogs',
  standalone: true,
  templateUrl: './blogs-new.component.html',
  styleUrls: ['./blogs-new.component.scss'],
  imports: [
    RouterLink,
    LocalDateTimePipe,
    SkeletonLoaderComponent,
    TranslatePipe,
  ],
  providers: [LocalDateTimePipe],
})
export class BlogsComponent implements OnInit, OnChanges {
  sectionTitle: string = 'Exclusive Content';
  sectionSubtitle: string = 'READ OUR';
  viewAllLink: string = '/blogs';
  isLoading: boolean = false;
  @Input() dir: any;
  @Input() translations: any;
  @Input() initialBlogs: any[] | null = null;
  @Input() disableAutoFetch = false;

  page: number = 1;
  itemsPerPage: number = ItemsPerPage;
  constructor(
    private homeService: LandingService,
    private toastService: ToastService,
    private initJQuery: JqueryInitService,
    public localeService: LocaleService
  ) {}
  blogItems: any[] = [];
  getBlogs() {
    this.isLoading = true;
    this.homeService
      .getBlogs(this.page || 1, this.itemsPerPage, { observe: 'response' })
      .subscribe({
        next: (fullResponse: any) => {
          this.isLoading = false;
          // Access the actual blog items from the response body
          const blogs = fullResponse.body?.data;
          this.blogItems = blogs;
          setTimeout(() => {
            this.initJQuery.initBlogsSlider(this.localeService.dir);
          }, 100);
        },
        error: (error) => {
          this.isLoading = false;
          this.toastService.showError(
            error?.error?.Error?.[0] ??
              'An error occurred while fetching Blogs.'
          );
        },
      });
  }

  ngOnInit(): void {
    const loadedFromInput = this.applyInitialBlogs();
    if (!loadedFromInput && !this.disableAutoFetch) {
      this.getBlogs();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialBlogs']) {
      this.applyInitialBlogs();
    }
  }
  ngAfterViewInit() {}
  ngOnDestroy() {}
  private applyInitialBlogs(): boolean {
    if (!Array.isArray(this.initialBlogs)) {
      return false;
    }

    this.blogItems = [...this.initialBlogs];
    this.isLoading = false;
    setTimeout(() => {
      this.initJQuery.initBlogsSlider(this.localeService.dir);
    }, 100);

    return true;
  }
}
